import ViewsRouter from '@/views/ViewsRouter.vue'
import ViewsReturn from '@/views/return/ViewsReturn.vue';
import {PERMISSIONS} from '@/constants';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/returns',
        name: 'return-parent',
        component: ViewsRouter,
        children: [
            {
                path: '',
                name: 'return.return',
                component: ViewsReturn,
                meta: {
                    requiresAuth: true,
                    permissions: [PERMISSIONS.EMPLOYEE]
                }
            }
        ]
    }
] as RouteRecordRaw[]
